import { FETCH_BASIC_SETUP_ASYNC, TOGGLE_DISMISS_ASYNC } from './constants'

export const fetchSetupSteps = () => ({
  type: FETCH_BASIC_SETUP_ASYNC.INITIATE,
})
export const fetchSetupStepsSuccess = (data) => ({
  type: FETCH_BASIC_SETUP_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchSetupStepsError = (error) => ({
  type: FETCH_BASIC_SETUP_ASYNC.ERROR,
  error,
})
export const fetchSetupStepsCancel = () => ({
  type: FETCH_BASIC_SETUP_ASYNC.CANCEL,
})

export const toggleDismiss = (body) => ({
  type: TOGGLE_DISMISS_ASYNC.INITIATE,
  payload: { body },
})
export const toggleDismissSuccess = (body) => ({
  type: TOGGLE_DISMISS_ASYNC.SUCCESS,
  payload: { body },
})
export const toggleDismissError = (error) => ({
  type: TOGGLE_DISMISS_ASYNC.ERROR,
  error,
})
export const toggleDismissCancel = () => ({ type: TOGGLE_DISMISS_ASYNC.CANCEL })

export default {
  // to props
  fetchSetupSteps,
  fetchSetupStepsCancel,
  toggleDismiss,
  toggleDismissCancel,
}
